import { z } from 'zod';

export const ProductInfoSchema = z.object({
  id: z.string(),
  brand: z.string(),
  description: z.string(),
  department: z.string(),
  item_code: z.string(),
  barcode: z.string(),
  last_cost: z.number(),
  size: z.string(),
  case_qty: z.number(),
});
